import * as F from 'components/form/FormLayout.styled';
import Authorization from 'components/global/Authorization';
import SubformHeader from 'components/global/SubformHeader';

import InvoiceTypeFormForSettings from 'pages/Settings/General/InvoiceTypeFormForSettings';

import BillingInfo from './BillingInfo';
import * as S from './GeneralSettings.styled';

const AccountBillingDetails = ({ isLoading, chargeAccount }) => {
	return (
		<S.GeneralSettingsContainer>
			<Authorization path="/company-settings/payment-details">
				{chargeAccount && (
					<SubformHeader
						boldTitle="accountTypeAndBillingDetails"
						lightTitle="accountTypeAndBillingDetails.description"
					/>
				)}
				<InvoiceTypeFormForSettings chargeAccount={chargeAccount} />
				<F.Line />
				{chargeAccount && (
					<SubformHeader
						boldTitle="billingAddress"
						lightTitle="billingAddress.description"
						className="mt-4"
					/>
				)}
				<BillingInfo isLoading={isLoading} />
			</Authorization>
		</S.GeneralSettingsContainer>
	);
};

export default AccountBillingDetails;
